import * as React from 'react';

const SvgIconPolicies11 = (props) => (
  <svg viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.627 29.477c.83-.893 1.905-1.647 2.528-1.925 1.276-.569 4.574-.495 5.371-3.977.418-1.823-1.669-3.223-3.922-3.8-1.228-.316-2.73-6.062-6.914-5.016-.085.02-.499-.03-1.274-.515-1.08-.677-1.864-1.547-2.008-1.878.476-1.184.143-2.032-.08-2.6-.204-.52-.209-.595-.046-.8.121-.153.488-.615.683-.634.045-.005.124.037.212.113.553.47.27 2.075 1.49 2.309 1.305.249 1.824-1.7 2.317-2.785 1.334-2.936 5.33-1.783 6.952-3.336.843-.807 1.375-1.787 1.512-2.722.944.276 1.848.645 2.7 1.1-.41 1.963 1.282 3.09 1.723 3.67-.107.399-.064.872.128 1.408a.67.67 0 0 1-.193.746c-.886.722-1.99 1.843-2.225 3.077-.55 2.886.485 4.195 1.568 5.095 2.518 2.092 4.674-.015 1.7 4.936-1.115 1.857-2.36 3.932-1.687 5.55a14.012 14.012 0 0 1-10.535 1.984ZM8.505 13.618c1.527 1.7 3.623 2.963 4.647 3.667a.078.078 0 0 1 .025.104c-1.192 2.036-.995 3.937.541 5.212 2.541 2.11 1.938 2.564.96 4.805-4.351-2.906-6.948-8.207-6.174-13.788ZM31.328 26.65c-.115-1.04.822-2.601 1.668-4.01 1.109-1.846 2.156-3.59 1.323-4.836-.789-1.18-1.954-.704-3.317-1.836-.8-.664-1.543-1.504-1.105-3.802.124-.652.746-1.463 1.752-2.284.656-.535.901-1.44.61-2.251-.116-.324-.121-.533-.09-.614.481-1.241-1.554-1.91-1.73-3.225 7.893 5.388 8.28 16.914.889 22.858Zm.194 1.542c9.095-6.569 8.417-20.376-1.197-26.058a15.41 15.41 0 0 0-18.175 1.86.677.677 0 0 0-.051.952c.247.277.67.3.945.05a14.095 14.095 0 0 1 12.094-3.4c-.062.734-.57 1.53-1.125 2.06-1.09 1.044-5.607.144-7.247 3.752-.23.504-.545 1.398-.83 1.845-.143-.505-.26-1.299-.894-1.838-.38-.323-.786-.466-1.208-.424-.758.074-1.284.737-1.598 1.133-.665.837-.369 1.59-.153 2.138.2.508.372.947.05 1.677-.307.7.332 1.466.542 1.717.86 1.03 3.02 2.739 4.337 2.41 3.213-.803 4.122 4.466 6.26 5.015 1.602.41 3.143 1.343 2.949 2.192-.599 2.614-3.064 2.358-4.609 3.047-.851.38-2.392 1.458-3.427 2.776a14.067 14.067 0 0 1-2.347-.994c.102-.238.213-.486.336-.746 1.12-2.365 1.045-3.595-1.602-5.794-1.27-1.054-.831-2.48-.24-3.49a1.435 1.435 0 0 0-.424-1.9c-.955-.657-3.751-2.341-5.056-4.28a14.109 14.109 0 0 1 2.432-4.982.677.677 0 0 0-.123-.945.667.667 0 0 0-.939.124c-3.742 4.906-4.417 11.962-.834 17.725 4.72 7.593 14.746 9.582 21.982 4.485a.618.618 0 0 0 .152-.107Z"
      fill="#E81528"
    />
    <mask
      id="icon-policies-11_svg__a"
      style={{
        maskType: 'alpha'
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={23}
      width={21}
      height={17}>
      <path d="M0 23.093h20.342v16.223H0V23.093Z" fill="#fff" />
    </mask>
    <g mask="url(#icon-policies-11_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.625 39.037c.13.182.335.28.543.28a.675.675 0 0 0 .543-1.069c-.88-1.226-4.775-3.274-6.854-5.337-.806-.8-2.22-3.565-2.59-4.73l-.915-3.315c-.105-.381.448-.626.641-.198 1.067 2.287 1.158 2.754 1.693 3.447a13.525 13.525 0 0 0 4.618 3.808l2.852 2.885c.131.133.303.199.475.199.591 0 .895-.724.475-1.15l-2.878-2.911-1.135-1.774c-.19-.396.317-.782.653-.433 3.894 4.119 3.707 3.994 3.908 4.093l4.179 2.042c2.28 1.115 2.118 3.546 2.172 3.72a.67.67 0 1 0 1.334-.124l-.059-.645a5.182 5.182 0 0 0-2.862-4.163l-4.069-1.99-3.635-3.865c-.577-.6-1.496-.721-2.185-.288a1.753 1.753 0 0 0-.783 1.81 12.161 12.161 0 0 1-2.003-2.04c-.384-.5-.396-.726-1.53-3.18-.334-.739-1.134-1.15-1.903-.977a1.687 1.687 0 0 0-1.249 2.095c1.233 4.464.842 3.081.926 3.35.422 1.34 1.934 4.306 2.93 5.293 1.134 1.125 2.725 2.219 4.13 3.184.582.4 2.235 1.506 2.578 1.983Z"
        fill="#E81528"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.86 23.18a1.668 1.668 0 0 0-2.06.9c-1.146 2.479-1.158 2.708-1.544 3.208a12.156 12.156 0 0 1-2.003 2.042 1.753 1.753 0 0 0-.783-1.81c-.688-.434-1.607-.313-2.19.293l-3.63 3.86-4.068 1.989c-3.036 1.484-2.863 4.648-2.924 4.836a.672.672 0 0 0 .605.733.67.67 0 0 0 .729-.61c.054-.172-.11-2.63 2.175-3.747 4.373-2.154 4.214-2.017 4.372-2.185l3.71-3.945c.344-.358.847.034.657.428l-1.134 1.774-2.878 2.912c-.421.425-.117 1.15.474 1.15.509 0 .53-.35 3.327-3.085 2.603-1.307 4.599-3.465 5.165-4.717l1.16-2.57c.167-.37.741-.183.619.262l-.907 3.282c-.37 1.166-1.784 3.93-2.59 4.73-2.073 2.059-5.961 4.104-6.847 5.33a.675.675 0 0 0 .54 1.07c.208 0 .412-.096.543-.277.674-.931 4.576-3.05 6.705-5.163.995-.987 2.507-3.954 2.93-5.293.084-.27-.262.948.916-3.318.243-.881-.227-1.794-1.07-2.08Z"
      fill="#E81528"
    />
    <mask
      id="icon-policies-11_svg__b"
      style={{
        maskType: 'alpha'
      }}
      maskUnits="userSpaceOnUse"
      x={10}
      y={40}
      width={12}
      height={6}>
      <path d="M10.379 40.585h11.307V46H10.379v-5.415Z" fill="#fff" />
    </mask>
    <g mask="url(#icon-policies-11_svg__b)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.346 44.438a.214.214 0 0 1-.213.215h-8.201a.214.214 0 0 1-.213-.215v-2.29c0-.119.095-.215.213-.215h8.201c.118 0 .213.096.213.214v2.291Zm-.213-3.853h-8.201c-.857 0-1.553.7-1.553 1.562v2.291A1.56 1.56 0 0 0 11.932 46h8.201c.856 0 1.553-.7 1.553-1.562v-2.29a1.56 1.56 0 0 0-1.553-1.563Z"
        fill="#E81528"
      />
    </g>
    <mask
      id="icon-policies-11_svg__c"
      style={{
        maskType: 'alpha'
      }}
      maskUnits="userSpaceOnUse"
      x={23}
      y={40}
      width={12}
      height={6}>
      <path d="M23.314 40.585H34.62V46H23.314v-5.415Z" fill="#fff" />
    </mask>
    <g mask="url(#icon-policies-11_svg__c)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.28 44.438a.214.214 0 0 1-.212.215h-8.202a.214.214 0 0 1-.213-.215v-2.29c0-.119.096-.215.213-.215h8.202c.117 0 .213.096.213.214v2.291Zm-.212-3.853h-8.202c-.856 0-1.552.7-1.552 1.562v2.291A1.56 1.56 0 0 0 24.866 46h8.202c.856 0 1.552-.7 1.552-1.562v-2.29a1.56 1.56 0 0 0-1.552-1.563Z"
        fill="#E81528"
      />
    </g>
  </svg>
);

export default SvgIconPolicies11;
